import React from 'react';
import PropTypes from 'prop-types';

const LastName = props => <span>{props.data.last_name}</span>;

LastName.propTypes = {
	data: PropTypes.object.isRequired,
};

export default LastName;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/last-name.js